import type { Deployment } from '../../common/types.tsx';

export const hasPermissionForAllIssues = (deployment: Deployment): boolean =>
	deployment.issueCount === deployment.issueIds.length;
